import {
  CTAButtons,
  CTAButtonsAlt,
} from "../../../../../global/components/Buttons/buttons";
import React, { useState, useEffect } from "react";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import Table from "../../../../Components/Table/Table";
import Pagination from "../../../../Components/Pagination/Pagination";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  TableActions,
  TableActionsNew,
} from "../../../../Components/Misc/Actions";
import "./style.css";
import { useTablesState } from "../States/States";
import {
  approvePaymentType,
  declinePaymentType,
  getPaymentType,
  createPaymentType,
  updatePaymentType,
  getFeeSetup,
  getWitholdingTaxSetup,
  createPaymentWitholdingTaxSetup,
  updateWitholdingTaxSetup,
  approveWitholdingTaxSetup,
  declineWitholdingTaxSetup,
} from "../../../../../../utils/redux/Finance/PaymentSetup/PaymentSetupSlice";
import { FiX, FiArrowLeft } from "react-icons/fi";
import DeclineModal from "../Components/DeclineModal";
import { URL } from "../../../../../../utils/routes";
import RouteLayout from "../../../../Components/Layout/RouteLayout";
import { Button } from "@mui/material";
import { GetVendorType } from "../../../../../../utils/redux/Global/GlobalSlice";
import { toast } from "react-toastify";
import {
  FilterButton,
  ProDropFilter,
} from "../../../../Components/Search/Search";

// Table Headers format:
let mockHeaders = [
  {
    title: "Service Name",
    key: "fee",
  },
  {
    title: "Payment Type",
    key: "paymentType",
  },
  {
    title: "Vendor Type",
    key: "vendorTypeId",
  },
  {
    title: "Percentage",
    key: "percentage",
  },
  // {
  //   title: "Status",
  //   key: "statusEnumText",
  // },
  {
    title: "Actions",
    key: null,
  },
];

// function convertDate(isoDate) {
//   let timestamp = Date.parse(isoDate);
//   let jsDate = new Date(timestamp);
//   let fDate = new Intl.DateTimeFormat("en-us", {
//     dateStyle: "short",
//     timeStyle: "short",
//   });
//   return fDate.format(jsDate);
// }

export default function WitholdingTaxSetup() {
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [comment, setComment] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [currentType, setCurrentType] = useState(null);
  const [declineStatus, setDeclineStatus] = useState(false);

  const [selectedItems, setSelectedItems] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const paymentTypes = useSelector(
    (state) => state?.paymentSetup?.paymentTypes
  );
  const feeSetup = useSelector(
    (state) => state?.paymentSetup?.FeeSetup?.result
  );

  const vendorsTypes = useSelector(
    (state) => state?.global?.vendorsTypes?.responseObject
  );

  const witholdingTaxSetup = useSelector(
    (state) => state?.paymentSetup?.witholdingTaxSetup?.result
  );

  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [approvalStatus, setFilter] = useState("all");

  // Initialize state with the provided object values
  const initialState = {
    feeSetupId: 0,
    paymentTypeId: 0,
    percentage: 0,
    vendorTypeId: 0,
  };

  const [formData, setFormData] = useState(initialState);

  // Handle change for input fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const closeModal = () => {
    setOpenModal(false);
    setComment("");
    setDeclineStatus(false);
    setCurrentType(null); // Clear current type
  };

  const filterBy = [
    {
      name: "Pending",
      filter: 1,
    },
    {
      name: "Approved",
      filter: 0,
    },
    {
      name: "Declined",
      filter: 7,
    },
  ];

  let mockRowOptions = [
    {
      name: "Edit",
      action: (item) => {
        setCurrentType(item);
        setComment(item?.name);
        setOpenModal(true);
        setFormData({
          feeSetupId: item?.feeSetupId || "",
          paymentTypeId: item?.paymentTypeId || "",
          percentage: item?.percentage || "",
          vendorTypeId: item?.vendorTypeId || "",
        });
      },
    },
    {
      name: "Approve",
      action: (item) => {
        const payload = {
          id: item?.id,
          status: 0,
        };
        dispatch(approveWitholdingTaxSetup(payload)).then((response) => {
          if (response?.payload?.successful === true) {
            setRefresh(!refresh);
            toast.success(response?.payload?.statusMessage);
          } else {
            toast.error(response?.payload?.statusMessage);
          }
        });
      },
    },
    {
      name: "Decline",
      action: (item) => {
        const payload = {
          id: item?.id,
          status: 7,
        };
        dispatch(declineWitholdingTaxSetup(payload)).then((response) => {
          if (response?.payload?.successful === true) {
            setRefresh(!refresh);
            toast.success(response?.payload?.statusMessage);
          } else {
            toast.error(response?.payload?.statusMessage);
          }
        });
      },
    },
  ];

  const getVendorName = (id) => {
    const vendor = vendorsTypes?.find((vendor) => vendor.id === id);
    return vendor?.name;
  };

  useEffect(() => {
    dispatch(getPaymentType({ pageSize: 10000, pageNumber: 1 }));
    dispatch(getFeeSetup({ pageSize: 10000, pageNumber: 1 }));
    dispatch(GetVendorType({ pageSize: 10000, pageNumber: 1 }));
    dispatch(
      getWitholdingTaxSetup({
        pageSize,
        pageNumber,
        Status: approvalStatus === "all" ? "" : approvalStatus,
      })
    );
  }, [approvalStatus, dispatch, pageNumber, pageSize, refresh]);

  const handleCreateWitholdingTaxSetup = async () => {
    if (
      !formData.feeSetupId ||
      !formData.paymentTypeId ||
      !formData.percentage ||
      !formData.vendorTypeId
    ) {
      return toast.error("All fields are required");
    }
    // Handle creation logic
    const payload = {
      feeSetupId: +formData.feeSetupId,
      paymentTypeId: +formData.paymentTypeId,
      percentage: +formData.percentage,
      vendorTypeId: +formData.vendorTypeId,
    };

    try {
      setLoading(true);
      let response;
      if (currentType) {
        // Editing existing
        response = await dispatch(
          updateWitholdingTaxSetup({
            id: currentType.id,
            ...payload,
          })
        );
      } else {
        // Creating new
        response = await dispatch(createPaymentWitholdingTaxSetup(payload));
      }
      if (response?.payload?.successful === true) {
        setRefresh(!refresh);
        toast.success(response?.payload?.statusMessage);
        setLoading(false);
        setOpenModal(false);
        setFormData(initialState);
      } else if (response?.payload?.successful === false) {
        toast.error(response?.payload?.statusMessage);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <RouteLayout>
      <button
        className="text-customGreen flex items-center gap-2 text-xl"
        onClick={() => {
          navigate(-1);
        }}
      >
        <FiArrowLeft />
        Back
      </button>

      <div className="w-full mt-5">
        {openModal && (
          <DeclineModal hideModal={setOpenModal}>
            <div
              className="bg-white w-full overflow-hidden"
              style={{
                borderTopLeftRadius: "5px",
                borderTopRightRadius: "5px",
              }}
            >
              <header className="w-full py-3 bg-customGreen px-4 flex items-center justify-between">
                <p className="text-white text-baseFont">
                  {declineStatus
                    ? "Reason for Delete"
                    : currentType
                    ? "Edit Witholding Tax Setup"
                    : "Add Withholding Tax Setup"}
                </p>
                <button
                  className="text-baseFont text-white"
                  onClick={closeModal}
                >
                  <FiX />
                </button>
              </header>
            </div>
            <section className="bg-white p-6">
              <div className="flex mt-6 mb-12 justify-between">
                <div className="flex gap-4 w-full">
                  <div className="flex flex-col gap-4 w-full">
                    {/* FEE SETUP */}
                    <div className="flex flex-col">
                      <div className="text-primary/50 text-sm mb-1">
                        Services Setup
                        <span className="text-red-500">*</span>
                      </div>
                      <select
                        className="block w-full px-4 py-2 text-gray-700 border border-slate-300 bg-slate-50 text-sm rounded-md focus:outline-none focus:ring-0"
                        name="feeSetupId"
                        value={formData.feeSetupId || ""}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Select service Setup
                        </option>
                        {feeSetup?.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.feeName}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* PAYMENT TYPE */}
                    <div className="flex flex-col">
                      <div className="text-primary/50 text-sm mb-1">
                        Payment Type
                        <span className="text-red-500">*</span>
                      </div>
                      <select
                        className="block w-full px-4 py-2 text-gray-700 border border-slate-300 bg-slate-50 text-sm rounded-md focus:outline-none focus:ring-0"
                        name="paymentTypeId"
                        value={formData.paymentTypeId || ""}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Choose Payment Type
                        </option>
                        {paymentTypes?.result?.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* PERCENTAGE */}
                    <div className="flex flex-col">
                      <div className="text-primary/50 text-sm mb-1">
                        Percentage
                        <span className="text-red-500">*</span>
                      </div>
                      <input
                        type="number"
                        className="block w-full px-4 py-2 text-gray-700 border border-slate-300 bg-slate-50 text-sm rounded-md focus:outline-none focus:ring-0"
                        name="percentage"
                        value={formData.percentage || ""}
                        onChange={handleChange}
                      />
                    </div>

                    {/* VENDOR TYPE */}
                    <div className="flex flex-col">
                      <div className="text-primary/50 text-sm mb-1">
                        Vendor Type
                        <span className="text-red-500">*</span>
                      </div>
                      <select
                        className="block w-full px-4 py-2 text-gray-700 border border-slate-300 bg-slate-50 text-sm rounded-md focus:outline-none focus:ring-0"
                        name="vendorTypeId"
                        value={formData.vendorTypeId || ""}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Choose Vendor Type
                        </option>
                        {vendorsTypes?.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full flex items-center justify-end gap-5 pt-3 px-7">
                <button
                  className="rounded-md py-1 px-4 text-baseFont text-customGreen"
                  style={{ border: "1px solid #305f32" }}
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button
                  disabled={loading}
                  className={`rounded-md py-1 px-4 text-baseFont ${
                    loading
                      ? "bg-gray-400 text-gray-700 border-gray-500 cursor-not-allowed"
                      : "bg-customGreen text-white border-customGreen"
                  }`}
                  style={{ border: "1px solid #305f32" }}
                  onClick={handleCreateWitholdingTaxSetup}
                >
                  {loading ? "Loading..." : currentType ? "Update" : "Proceed"}
                </button>
              </div>
            </section>
          </DeclineModal>
        )}

        <div
          className={`${DashboardStyle.dashboard_table_holder} rounded p-10 bg-white `}
        >
          <div className="w-full flex items-center justify-between mb-1">
            <h1 className="text-customGreen text-xl font-semibold">
              Witholding Tax Setup
            </h1>
            <CTAButtons
              onClick={() => {
                setOpenModal(true);
              }}
            >
              Add Witholding Tax Setup
            </CTAButtons>
          </div>
          <div className={DashboardStyle.dashboard_filter}>
            <ProDropFilter
              filter={approvalStatus}
              setFilter={setFilter}
              name={"Approval Status"}
              filterBy={filterBy}
              value={approvalStatus}
            />
            <FilterButton onClick={() => setRefresh(!refresh)} name="" />
          </div>
          <Table>
            <thead>
              <tr>
                <th>
                  <p>ID</p>
                </th>
                {mockHeaders.map((header) => (
                  <th key={header.key}>{header.title}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <RequestTable
                isLoading={false}
                data={witholdingTaxSetup}
                keys={mockHeaders.map((header) => header.key)}
                selectable={true}
                rowOptions={mockRowOptions}
                getVendorName={getVendorName}
                selectedItems={selectedItems}
              />
            </tbody>
          </Table>
        </div>

        {/* <Pagination
          last_page={paymentTypes?.totalPages}
          present_page={paymentTypes?.currentPage}
          totalRows={paymentTypes?.totalRows}
          pageSize={pageSize}
          setPageSize={(page) => setPageSize(page)}
          click={(page) => setPageNumber(page)}
        /> */}
      </div>
    </RouteLayout>
  );
}

function RequestTable({ data, getVendorName, rowOptions }) {
  return (
    <>
      {data?.map((item, index) => (
        <tr key={item.id}>
          <td>
            <p>{index + 1}</p>
          </td>
          <td>{item.fee}</td>
          <td>{item.paymentType}</td>
          <td>{getVendorName(item.vendorTypeId)}</td>
          <td>{item?.percentage}</td>
          {/* <td></td> */}
          <td>
            <TableActionsNew
              url={`/dashboard/finance/${URL.WitholdingTaxSetup}/${item.id}/view`}
              actions={rowOptions.map((option) => ({
                name: option.name,
                action: () => option.action(item),
              }))}
            />
          </td>
        </tr>
      ))}
    </>
  );
}
